import { isFirstDegreeOrHigher, isSecondDegreeOrHigher } from './gradeAccess';

/** Most builder tools — 1st degree black belt and above. */
export function canAccessBuilders(user) {
  return isFirstDegreeOrHigher(user);
}

export const BUILDER_ACCESS_DENIED_MESSAGE =
  'This builder is available to 1st degree black belts and above.';

/** Builders hub — any signed-in student. */
export function canAccessBuilderMain(user) {
  return user != null && user.id != null;
}

export const BUILDER_MAIN_DENIED_MESSAGE = 'Please sign in to access Builders.';

/** Builders available to all students (not only black belts). */
export const STUDENT_BUILDER_SCREENS = new Set(['StoryBuilder', 'RoutineBuilder']);

export function canAccessBuilderScreen(screenName, user) {
  if (!user?.id) return false;
  if (screenName === 'BuilderMain') return canAccessBuilderMain(user);
  if (STUDENT_BUILDER_SCREENS.has(screenName)) return true;
  return isFirstDegreeOrHigher(user);
}

export function getBuilderAccessDeniedMessage(screenName) {
  if (screenName === 'BuilderMain') return BUILDER_MAIN_DENIED_MESSAGE;
  if (STUDENT_BUILDER_SCREENS.has(screenName)) return BUILDER_MAIN_DENIED_MESSAGE;
  return BUILDER_ACCESS_DENIED_MESSAGE;
}

/** Tao 2 reader — 2nd degree black belt and above (super users included). */
export function canAccessTao2(user) {
  return isSecondDegreeOrHigher(user);
}

export const TAO2_ACCESS_DENIED_MESSAGE =
  'Tao 2 is available to 2nd degree black belts and above.';

export const BUILDER_SCREEN_NAMES = [
  'BuilderMain',
  'ExerciseBuilder',
  'ExerciseTypeBuilder',
  'CourseBuilder',
  'QuotesBuilder',
  'BreaksBuilder',
  'CreateBreaksBuilder',
  'StoryBuilder',
  'CourseEditor',
  'AssignmentsBuilder',
  'RoutineBuilder',
  'RecordPageLayoutBuilder',
  'ClassBuilder',
  'ChangeGrade',
  'CreateUser',
  'DimMakBuilder',
  'DimMakMeridiansBuilder',
  'DimMakPointsBuilder',
];
